$(() => {
  const amount_per_statement = () => {
    const processed_dollar_volume = parseInt($('#processed-dollar-volume-per-month').val().replace(',', ''), 10);
    const patient_statements_per_month = parseInt($('#patient-statements-per-month').val().replace(',', ''), 10);

    return (processed_dollar_volume * 0.35 / patient_statements_per_month)
  };

  const run = () => {
    if ($('#amount-per-statement-overridden').val() === '0') {
      $('#amount-per-statement').val(accounting.formatMoney(amount_per_statement(), '', 0));
    }
  };

  run();

  $('#processed-dollar-volume-per-month, #patient-statements-per-month').blur(() => {
    run();
  });

  $('#amount-per-statement').blur(() => {
    $('#amount-per-statement-overridden').val('1');
  });
});
